<template>
	<div class="container__analise__detalhada">
		<ContentHeader class="dashboard__analise">
			<SubHeader
				:title="`${$t('hello')}, ${email}`"
				subtitle=""
				class="dashboard__analise"
			>
				<template #actions />
				<template #main>
					<div style="margin-top: 2rem; display: flex; justify-content: space-around">
						<Tab
							:text="$t('analysis')"
							:to="{ name: 'analise' }"
							:active="$route.path === '/analise'"
						/>
						<Tab
							:text="$t('indicators')"
							:to="{ name: 'indicadores' }"
							:active="$route.path === '/indicadores'"
						/>
						<Tab
							:text="$t('map')"
							:to="{ name: 'mapa' }"
							:active="$route.path === '/mapa'"
						/>
					</div>
				</template>
			</SubHeader>
		</ContentHeader>
		<ContentBody class="dashboard__analise">
			<router-view />
		</ContentBody>
	</div>
</template>

<script setup>
import { computed, onUnmounted } from 'vue'
import ContentHeader from '../../components/ContentHeader/ContentHeader.vue'
import ContentBody from '../../components/ContentBody/ContentBody.vue'
import SubHeader from '../../components/SubHeader/SubHeader.vue'
import Tab from '../../components/Tab/Tab.vue'
import { useChangeCase } from '@vueuse/integrations/useChangeCase'
import { useStore } from '../../store/modules/moduleDashboardAnalytics'

const dashboardStore = useStore()

const email = computed(() => {
	return useChangeCase(localStorage.getItem('username').split('@')[0], 'capitalCase').value
})

onUnmounted(() => {
	console.log('aqui foi')
	dashboardStore.dispatch('resetCurrentState')
})
</script>

<style>
/* .container__subheader__top__page__info__title {
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: 36px !important;
  line-height: 49px !important;
} */

.container__subheader.dashboard__analise label {
	font-style: normal !important;
	font-weight: 700 !important;
	font-size: 36px !important;
	line-height: 49px !important;
}

.container__subheader__top__page__info {
	width: 33% !important;
}

.container__contentheader.dashboard__analise > div {
	max-width: 80% !important;
}

.container__contentbody.dashboard__analise {
	max-width: 80% !important;
}
</style>
